// MARK: Helper functions for currency related constants

export const ccyIsoCodeToSymbolMap = {
    'EUR': '€',
    'USD': '$',
    'GBP': '£',
};

export const supportedCurrencies = {
    "EUR": "Euro (€)",
    "GBP": "British Pound (£)",
    "USD": "US Dollar ($)",
  };

export const defaultCurrencyByCountry = {
    "US" : "USD",
    "IE" : "EUR",
    "GB" : "GBP",
    "UK" : "GBP",
    "FR" : "EUR",
    "ES" : "EUR",
    "IT" : "EUR",
    "DE" : "EUR",
    "LU" : "EUR",
    "LT" : "EUR",
    "LV" : "EUR",
    "PL" : "EUR",
    "PT" : "EUR",
    "NL" : "EUR",
    "BE" : "EUR",
    "AT" : "EUR",
    "CZ" : "EUR",
    "SK" : "EUR",
    "HU" : "EUR",
    "RO" : "EUR",
    "BG" : "EUR",
    "HR" : "EUR",
    "SI" : "EUR",
    "EE" : "EUR",
    "FI" : "EUR",
    "SE" : "EUR",
    "DK" : "EUR",
    "NO" : "EUR",
    "IS" : "EUR",
    "CH" : "EUR",
    "LI" : "EUR",
    "MC" : "EUR",
    "SM" : "EUR",
  };

  export const countryFlags = {
    "IE": "🇮🇪",
    "GB": "🇬🇧",
    "UK": "🇬🇧",
    "FR": "🇫🇷",
    "ES": "🇪🇸",
    "IT": "🇮🇹",
    "DE": "🇩🇪",
    "US": "🇺🇸",
    "LU": "🇱🇺",
    "LT": "🇱🇹",
    "LV": "🇱🇻",
    "PL": "🇵🇱",
    "PT": "🇵🇹",
    "NL": "🇳🇱",
    "BE": "🇧🇪",
    "AT": "🇦🇹",
    "CZ": "🇨🇿",
    "SK": "🇸🇰",
    "HU": "🇭🇺",
    "RO": "🇷🇴",
    "BG": "🇧🇬",
    "HR": "🇭🇷",
    "SI": "🇸🇮",
    "EE": "🇪🇪",
    "FI": "🇫🇮",
    "SE": "🇸🇪",
    "DK": "🇩🇰",
    "NO": "🇳🇴",
    "IS": "🇮🇸",
    "CH": "🇨🇭",
    "LI": "🇱🇮",
    "MC": "🇲🇨",
    "SM": "🇸🇲",
    "VA": "🇻🇦",
    "AD": "🇦🇩",
    "ME": "🇲🇪",
    "MT": "🇲🇹",
  };
